<template>
  <auto-width v-slot="{ width }">
    <v-virtual-scroll
      :items="chunks"
      :item-height="(width / n) / aspectRatio + padding"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:default="{ item, index }">
        <div
          v-for="gridItem, i in item"
          v-if="index * n + i < items.length"
          class="d-inline-block relative"
          v-bind:style="{ padding: `${padding}px`, width: `${100 / n}%` }"
        >
          <slot name="default" v-bind="{ item: gridItem, index: index * n + i }"></slot>
        </div>
      </template>
    </v-virtual-scroll>
  </auto-width>
</template>


<script>
import AutoWidth from '@/components/AutoWidth.vue';

export default {
  name: 'v-virtual-scroll-row',

  components: {
    AutoWidth
  },

  props: [ 'items', 'n', 'aspect-ratio', 'padding' ],

  computed: {
    chunks() {
      return _.chunk(this.items, this.n);
    }
  }
}
</script>
